import { useNavigate } from "react-router-dom";
import { Sparkles, Lock, Award, Check } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useExitIntent } from "@/hooks/useExitIntent";

const ExitIntentPopup = () => {
  const navigate = useNavigate();
  const { showPopup, dismissPopup } = useExitIntent();

  const handleSignup = () => {
    dismissPopup();
    navigate("/signup");
  };

  const handleSeePricing = () => {
    dismissPopup();
    navigate("/pricing");
  };

  return (
    <Dialog open={showPopup} onOpenChange={dismissPopup}>
      <DialogContent className="w-[calc(100%-2rem)] max-w-md mx-4 rounded-lg p-4 sm:p-6" hideCloseButton>
        <DialogHeader className="text-center sm:text-center">
          <div className="mx-auto mb-3 sm:mb-4 flex items-center gap-2">
            <span className="inline-flex items-center gap-1 rounded-full bg-primary/10 px-3 py-1 text-xs font-semibold text-primary">
              <Sparkles className="h-3.5 w-3.5" />
              50 premiers restaurants
            </span>
          </div>
          <DialogTitle className="text-lg sm:text-xl font-playfair">
            Attendez, il reste des places Fondateur
          </DialogTitle>
          <DialogDescription className="text-sm sm:text-base">
            L'Offre de Printemps 2026 est réservée aux 50 premiers restaurants qui rejoignent Piktable.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-3 sm:space-y-4 py-3 sm:py-4">
          {/* Offer highlight */}
          <div className="rounded-lg bg-primary/10 border border-primary/20 p-3 sm:p-4 text-center">
            <div className="flex items-baseline justify-center gap-2">
              <span className="font-playfair text-3xl sm:text-4xl font-bold text-primary">29</span>
              <span className="text-sm sm:text-base text-muted-foreground">CHF / mois</span>
            </div>
            <p className="mt-1 inline-flex items-center gap-1 text-xs sm:text-sm font-semibold text-primary">
              <Lock className="h-3.5 w-3.5" />
              Verrouillé à vie
            </p>
            <p className="text-xs text-muted-foreground mt-1">
              60 jours gratuits. Tarif jamais augmenté
            </p>
          </div>

          {/* Benefits */}
          <div className="flex flex-col gap-2 text-sm">
            <div className="flex items-start gap-2 text-muted-foreground">
              <Award className="h-4 w-4 text-primary mt-0.5 flex-shrink-0" />
              <span>Logo « Restaurant Fondateur » sur piktable.ch</span>
            </div>
            <div className="flex items-start gap-2 text-muted-foreground">
              <Check className="h-4 w-4 text-primary mt-0.5 flex-shrink-0" />
              <span>Accès prioritaire aux nouveautés</span>
            </div>
            <div className="flex items-start gap-2 text-muted-foreground">
              <Check className="h-4 w-4 text-primary mt-0.5 flex-shrink-0" />
              <span>1 h de coaching à la mise en ligne</span>
            </div>
          </div>

          {/* CTA */}
          <Button
            className="w-full"
            size="lg"
            onClick={handleSignup}
          >
            Rejoindre les Fondateurs
          </Button>

          <p className="text-xs text-center text-muted-foreground">
            Sans carte bancaire. Avant le 30 septembre 2026
          </p>

          {/* Secondary actions */}
          <div className="flex flex-col gap-1">
            <button
              onClick={handleSeePricing}
              className="w-full text-center text-sm text-primary hover:underline transition-colors"
            >
              Voir tous les tarifs
            </button>
            <button
              onClick={dismissPopup}
              className="w-full text-center text-xs text-muted-foreground hover:text-foreground transition-colors"
            >
              Non merci, je reviendrai plus tard
            </button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ExitIntentPopup;
